import dynamic from 'next/dynamic';

export const InspiringSearchRecommendationsDynamicWrapper = dynamic(
  () => import(/* webpackChunkName: 'Component' */ './InspiringSearchRecommendations.LazyWrapper'),
  { ssr: false },
);
